<template lang="html">
    <div class="main-container">
        <ul class="breadcrumb">
            <li>
                <a href="#">Organisation</a>
            </li>
            <li>
                <a href="#">Utilities</a>
            </li>
            <li>
                <a href="#">Loan</a>
            </li>
            <li>Loan Master</li>
        </ul>
        <tl-header type="h1">
            <div class="main-header">Import Employee Loan Details</div>
        </tl-header>

        <div class="twoColumnGrid">
            <txt autofocus="autofocus" label='Employee Code / Name' type="text" v-model='formData.loan_name' name="employee_code_name"
                placeholder="" v-validate="'required'" :classname="errors.has('employee_code_name')" :errormsg="errors.first('employee_code_name')">
            </txt>
            <div>
                <tl-select class="max-width-300" label="Map" :value="formData.mapType" :options="mapOptionsArray" @change="(val)=>changeMapType(val)" />
            </div>
        </div>
        <div class="singleColumnGrid">
            <txt autofocus="autofocus" label='Abbrevation' type="text" v-model='formData.loan_name' name="employee_code_name" placeholder=""
                v-validate="'required'" :classname="errors.has('employee_code_name')" :errormsg="errors.first('employee_code_name')">
            </txt>
            <div>
                <span>Effective Date</span>
                <date-picker @datevalue="(val)=>formData.effective_date=val" :value="formData.effective_date" v-model="formData.effective_date"
                    :formatDate="'dd-MM-yyyy'" />
            </div>
            <txt autofocus="autofocus" label='Applicable Rate' type="text" v-model='formData.loan_name' name="employee_code_name" placeholder=""
                v-validate="'required'" :classname="errors.has('employee_code_name')" :errormsg="errors.first('employee_code_name')">
            </txt>
        </div>

        <div class="top-padding-20">
            <tl-checkbox class="padding-10" label="Is Active" @change="(val)=>isActiveChange(val)">
            </tl-checkbox>
        </div>

        <div class="top-padding-20">
            <btn-grp>
                <btn text="Save" type="primary" @click="save()" />
            </btn-grp>
        </div>

        <div class="top-padding-20">
            <data-table :columns="columnNames" :tableData="loansMasterData" :checkbox="false" :showinrow="false">
                <!-- <template v-slot:rowcontent="slotprops">{{loansMasterData[slotprops.value.index]}}
                            <div class="action-section" v-if="slotprops.value.column.key=='action'"> 
                            <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon">
                            <ul class="action-menu" v-show="loansMasterData[slotprops.value.index].showDropDown" >
                                <li> <span class="">View</span></li>
                                <li><span class="">DownLoad </span></li>
                            </ul>
                            </div>
                        </template> -->
            </data-table>
        </div>



        <div class="btn-group">
            <bottom-action-container>
                <btn-grp slot="end">
                    <btn text="Close" type="secondary" @click="close" />
                </btn-grp>
            </bottom-action-container>
        </div>

    </div>
</template>

<script>

    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex';

    export default {
        name: 'loanMaster',
        computed: {
            ...mapState({
            }),
            ...mapGetters({
                orgid: "onboard/organization/orgid"
            }),
        },

        data() {
            return {
                mapOptionsArray: ['Map 1', 'Map 2', 'Map 3'],
                formData: {
                    loan_name: '',
                    mapType: '',
                    effective_date: ''
                },
                columnNames: [
                    {
                        label: 'Sl.No',
                        key: 'slno'
                    },
                    {
                        label: 'Loan Name',
                        key: 'loanName'
                    },
                    {
                        label: 'Loan Abbrevation',
                        key: 'loanAbbrevation'
                    },
                    {
                        label: 'Map To',
                        key: 'mapTo'
                    },
                    {
                        label: 'Notified interest rate % (IT Act)',
                        key: 'notifiedInterest'
                    },
                    {
                        label: 'Is Active',
                        key: 'isActive'
                    },
                    {
                        label: "Action",
                        key: "action"
                    }
                ],
                loansMasterData: [
                    {
                        id: 11,
                        slno: 1,
                        loanName: "abcd1234",
                        loanAbbrevation: 'Adhaar Card',
                        mapTo: "Map 1",
                        notifiedInterest: "18",
                        isActive: "Active",
                        action: "",
                        showDropDown: false
                    },
                    {
                        id: 22,
                        slno: 2,
                        loanName: "abcd1234",
                        loanAbbrevation: 'Adhaar Card',
                        mapTo: "Map 2",
                        notifiedInterest: "18",
                        isActive: "Active",
                        action: "",
                        showDropDown: false
                    },
                    {
                        id: 33,
                        slno: 3,
                        loanName: "abcd1234",
                        loanAbbrevation: 'Adhaar Card',
                        mapTo: "Map 3",
                        notifiedInterest: "18",
                        isActive: "Active",
                        action: "",
                        showDropDown: false
                    },
                    {
                        id: 44,
                        slno: 4,
                        loanName: "abcd1234",
                        loanAbbrevation: 'Adhaar Card',
                        mapTo: "Map 4",
                        notifiedInterest: "18",
                        isActive: "Active",
                        action: "",
                        showDropDown: false
                    },
                ],
            }
        },

        mounted() {

        },

        methods: {
            ...mapActions({
            }),

            changeMapType(val) {

            },

            isActiveChange(val) {

            },

            save() {

            },

            close() {
                this.$router.push({
                    path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/loans`
                })
            },
        }


    }

</script>

<style lang="scss" scoped>
    .top-padding-20 {
        padding: 20px 0px 0px;
    }

    .padding-10 {
        padding: 10px 0px;
    }

    .action-section {
        margin: 0px;
        text-align: center;

        img {
            width: auto;
        }
        .action-menu {
            top: 0px;
            right: 54px;
            left: -182px;
            li {
                padding: 0px;
                padding: 10px 25px;
                font-weight: 500;
                &:not(:last-child) {
                    border-bottom: solid 1px #97979759;
                }
            }
        }
    }

    .max-width-300{
        max-width: 300px;
    }
</style>